export enum TrainingTypeModel
{
  IDD = 0,
  Compliance = 1,
  General = 2
}
